<template>
  <component
    v-bind:is="tag"
    class="mui-editable-list"
    contenteditable="true"
    ref="mui-content-editable-list"
    @blur="handleBlur"
    @click="handleClick"
    @input="handleInput"
    @keydown="handleKeyDown"
    @paste="handlePaste"
    :data-placeholder="placeholder">
    <li
      :class="{
        'mui-editable-list-item': true,
        'mui-list-section': listItemIsSection(item.text)
      }"
      :data-list-item-key="item.key"
      v-for="item in items"
      :key="item.key">{{item.text}}</li>
  </component>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/database'
const EDITABLE_LIST_ITEM = '<li class="mui-editable-list-item"></li>'
export default {
  name: 'mui-content-editable-list',
  props: {
    items: [Array, NodeList],
    placeholder: {
      type: String,
      default: 'Add item'
    },
    tag: {
      type: String,
      default: 'ul'
    },
    type: {
      type: String,
      required: true
    }
  },
  model: {
    prop: 'items'
  },
  methods: {
    handleInput (ev) {
      let type = this.type
      this.$nextTick(() => {
        let value = Array.from(this.$el.childNodes).map((node, priority) => {
          let o = {
            key: node.getAttribute('data-list-item-key'),
            text: node.innerText.trim(),
            priority
          }
          if (/.{1,}:$/.test(o.text)) o.section = true
          return o
        })
        this.$emit('input', { type, value })
      })
    },
    // asObject () {
    //   let result = {}
    //   this.$el.childNodes.forEach((node, index) => {
    //     let key = node.getAttribute('data-list-item-key')
    //     let text = node.innerText.trim()
    //     result[key] = {
    //       text,
    //       priority: index
    //     }
    //     if (text.length > 1 && text.endsWith(':')) result[key]['section'] = true
    //   })
    //   return result
    // },
    // asArray () {
    //   let txt = this.$el.innerText
    //   if (!txt) return []
    //
    //   let arr = txt.replace(/\n$/, '').split('\n')
    //   // Reduce the array to remove empty strings and assign section ids
    //   return arr.reduce((result, s) => {
    //     s = s.trim()
    //     if (s !== '') {
    //       let o = { text: s }
    //       if (s.length > 1 && s.endsWith(':')) o['section'] = true
    //       result.push(o)
    //     }
    //     return result
    //   }, [])
    // },
    resetEmptyStateAndBlur (target) {
      if (target.innerText.trim() === '') {
        document.execCommand('selectAll')
        document.execCommand('delete')
      }
      target.blur()
    },
    generateFirebaseKey () {
      return firebase.database().ref().push().key
    },
    handleBlur (e) {
      e.preventDefault()
      this.resetEmptyStateAndBlur(e.target)
    },
    handleClick (e) {
      e.preventDefault()
      let target = e.target
      // TODO: This is inserting a new line if only empty items exist
      if (['UL', 'OL'].indexOf(target.nodeName) !== -1 &&
        target.innerText.trim() === '' &&
        target.innerHTML.trim() === '') {
        this.insertListItem()
      }
      target.focus()
    },
    handleKeyDown (e) {
      // TODO: Escape key closes the dialog, it shouldn't when focused on a field. Expect it to blur the field.
      if (e.keyCode === 27) return this.resetEmptyStateAndBlur(e.target)
      if (e.target.innerText.trim() === '' && e.target.innerHTML === '') {
        this.insertListItem()
      }
    },
    handlePaste (ev) {
      const clipboardText = this.getClipboardText(ev)
      ev.preventDefault()
      document.execCommand('insertText', false, clipboardText)
    },
    getClipboardText (ev) {
      if (window.clipboardData && window.clipboardData.getData) {
        return window.clipboardData.getData('Text')
      } else if (ev.clipboardData && ev.clipboardData.getData) {
        return ev.clipboardData.getData('text/plain')
      }
    },
    insertListItem () {
      document.execCommand('insertHTML', false, EDITABLE_LIST_ITEM)
    },
    listItemIsSection (target) {
      return target.length > 1 && target.endsWith(':')
    },
    isListItem (target) {
      return target.tagName === 'LI'
    }
  },
  mounted () {
    let observerConfig = {
      subtree: true,
      childList: true,
      characterData: true,
      characterDataOldValue: true
    }
    var observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        let target = mutation.target

        switch (mutation.type) {
          case 'characterData':
            if (target.parentNode) {
              if (this.listItemIsSection(target.data)) {
                target.parentNode.classList.add('mui-list-section')
              } else {
                target.parentNode.classList.remove('mui-list-section')
              }
            }
            break
          case 'childList':
            if (['UL', 'OL'].indexOf(mutation.target.tagName) !== -1 &&
              mutation.addedNodes.length > 0) {
              let node = mutation.addedNodes[0]
              node.setAttribute(
                'data-list-item-key',
                this.generateFirebaseKey()
              )
              if (node.innerHTML === '<br>') node.innerHTML = ''
            }

            // TODO: Last element is a plus symbol using css :empty
            // Requires CSS to be uncommented
            //
            // if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].nodeName === 'BR') {
            //   mutation.addedNodes[0].remove()
            // }
            if (this.listItemIsSection(target.innerText)) {
              target.classList.add('mui-list-section')
            } else {
              target.classList.remove('mui-list-section')
            }
            break
        }
      })
    })
    observer.observe(this.$el, observerConfig)
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
ul.mui-editable-list--unordered
  padding-left: 0
  li.mui-editable-list-item
    margin-left: 20px
.mui-editable-list
  margin-top: 0
  padding-top: 0
  width: 100%
  li.mui-editable-list-item
    padding: 0 0 0 16px
    margin: 0 0 0 16px
    span
      display: inline-block
      vertical-align: top
      white-space: pre-wrap
      width: 100%
      &:focus
        outline: none
    label
      color: $textColor
      &.placeholder
        color: rgba(0,0,0,0.54)
    // &:last-child:empty
    //   list-style-type: none
    //   &:before
    //     content: '+'
    //     left: -34px
    //     margin-right: -8px
    //     position: relative
    &.mui-list-section
      margin-left: -16px
      list-style: none
  &.mui-editable-list--empty
    list-style: none
</style>



// WEBPACK FOOTER //
// src/components/MUIContentEditableList.vue